<template>
    <div>
        <b-modal ref="showCardModal" id="showCardModal" centered hide-footer hide-header>

            <div class="close" @click="$bvModal.hide('showCardModal')"><img src="/svg/close.svg" alt=""></div>

            <div class="d-block position-relative">
                <h2 class="color-primary as-h1 mb-32">Получи скидку 3% на всё!</h2>

                <div class="title-4 mb-40">
                    Пройдите полную регистрацию и получите нашу карту клиента, а вместе с ней 3% на всю продукцию МОЙ РЕНТАЛ и много других преимуществ!
                </div>

                <img src="/img/icons/logo_225.png" alt="" class="icon">
                <div>
                    <button @click="close()" class="button btn-large">Оформить карту клиента</button>
                </div>


            </div>
        </b-modal>
    </div>
</template>

<script>

    export default {

        data() {
            return {

            }
        },

        methods: {
            close() {
                this.$bvModal.hide('showCardModal');
                this.$router.push({ path: '/account/card' });
            }
        }


    }
</script>
